<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64" 
        type="card"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t("dashboard") }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      
      <!-- Search Date and Provider -->
      <v-card class="card2 mt-4 mx-2">
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="2" class="mt-3">
              <v-autocomplete
                id="provider-autocomplete-dashboard"
                label="Provider"
                :items="listDDProvider"
                item-title="providerName"
                item-value="providerName"
                v-model="provider"
                clearable
                variant="outlined"
                density="compact"
                color="primary"
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="40vw">
                    <template v-slot:activator="{ props }">
                      <v-icon 
                        size="x-small" 
                        style="position:absolute; top:0px; right:-6px"
                        v-bind="props"
                      >mdi-information-outline</v-icon>
                    </template>
                    <span>{{$t('_InfoProvider')}}</span>
                  </v-tooltip> 
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="mt-3">
              <v-menu v-model="startDateFlag" :close-on-content-click="false" location="bottom" min-width="auto">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    id="startdate-field-dashboard"
                    v-model="startDate"
                    label="Start Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    variant="outlined"
                    clearable
                    color="primary"
                    density="compact"
                    v-bind="props"
                  ></v-text-field>
                </template> 
                <v-date-picker v-model="startDate"
                color="primary"
                @update:model-value="val => { startDate = formatDate(val); startDateFlag = false }"
                 :max="endDate != null ? endDate : null"/>
              </v-menu>
            </v-col>
            
            <v-col cols="12" sm="6" md="3" class="mt-3">
              <v-menu v-model="endDateFlag" :close-on-content-click="false" location="bottom" min-width="auto">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    id="enddate-field-dashboard"
                    v-model="endDate"
                    label="End Date"
                    prepend-icon="mdi-calendar"
                    readonly
                    variant="outlined"
                    clearable
                    density="compact"
                    v-bind="props"
                                    color="primary"

                  ></v-text-field>
                </template>
                
                <v-date-picker v-model="endDate"
                                color="primary"
 
                :min="startDate != null ? startDate : null"
                @update:model-value="val => { endDate = formatDate(val); endDateFlag = false }"/>
              </v-menu>

            </v-col>
            <v-col cols="12" sm="6" md="2">
              <v-btn 
                class="mt-3"
                color="primary"
                variant="elevated"
                icon="mdi-magnify"
                @click="Search"
                size="small"
              ></v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-row class="my-4">
        <v-col cols="12" sm="12" md="6">
          <v-skeleton-loader :loading="loadingCard" type="card">
            <v-card class="card-1 d-flex align-center mb-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="76"
                height="76"
                viewBox="0 0 76 76"
                fill="none"
                class="ml-4"
              >
                <g clip-path="url(#clip0_32_433)">
                  <path
                    d="M38 6.33337C55.4895 6.33337 69.6667 20.5105 69.6667 38C69.6667 55.4895 55.4895 69.6667 38 69.6667C20.5105 69.6667 6.33334 55.4895 6.33334 38C6.33334 20.5105 20.5105 6.33337 38 6.33337ZM38 12.6667C31.2812 12.6667 24.8376 15.3357 20.0866 20.0867C15.3357 24.8376 12.6667 31.2812 12.6667 38C12.6667 44.7189 15.3357 51.1625 20.0866 55.9134C24.8376 60.6643 31.2812 63.3334 38 63.3334C44.7188 63.3334 51.1625 60.6643 55.9134 55.9134C60.6643 51.1625 63.3333 44.7189 63.3333 38C63.3333 31.2812 60.6643 24.8376 55.9134 20.0867C51.1625 15.3357 44.7188 12.6667 38 12.6667ZM38 19C38.7756 19.0001 39.5242 19.2849 40.1038 19.8003C40.6835 20.3157 41.0538 21.0259 41.1445 21.7962L41.1667 22.1667V36.689L49.7388 45.2612C50.3068 45.8311 50.6365 46.5957 50.6611 47.3999C50.6856 48.2041 50.4032 48.9875 49.871 49.5909C49.3389 50.1944 48.5971 50.5727 47.7962 50.649C46.9952 50.7253 46.1953 50.4938 45.5588 50.0017L45.2612 49.7389L35.7612 40.2389C35.269 39.7463 34.9529 39.1052 34.8618 38.4149L34.8333 38V22.1667C34.8333 21.3269 35.167 20.5214 35.7608 19.9275C36.3547 19.3337 37.1601 19 38 19Z"
                    fill="#999999"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_32_433">
                    <rect width="76" height="76" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <label
                style="
                  color: #4c4c4c;
                  padding-left: 1em;
                  font-weight: 700;
                  font-size: 18px;
                "
              >
                {{ $t("totalUser") }}
                <br /><span style="color: #8e8e8e; font-size: 40px">{{ totalusage }}</span>
                <span style="color: #8e8e8e">/ {{$t("WithinThisDaysAgo")}} {{ daysDifference }} {{$t("Day")}}</span> 
              </label>
            </v-card>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <v-skeleton-loader :loading="loadingCard" type="card">
            <v-card class="card-1 d-flex align-center mb-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="76"
                height="76"
                viewBox="0 0 76 76"
                fill="none"
                class="ml-4"
              >
                <g clip-path="url(#clip0_32_433)">
                  <path
                    d="M38 6.33337C55.4895 6.33337 69.6667 20.5105 69.6667 38C69.6667 55.4895 55.4895 69.6667 38 69.6667C20.5105 69.6667 6.33334 55.4895 6.33334 38C6.33334 20.5105 20.5105 6.33337 38 6.33337ZM38 12.6667C31.2812 12.6667 24.8376 15.3357 20.0866 20.0867C15.3357 24.8376 12.6667 31.2812 12.6667 38C12.6667 44.7189 15.3357 51.1625 20.0866 55.9134C24.8376 60.6643 31.2812 63.3334 38 63.3334C44.7188 63.3334 51.1625 60.6643 55.9134 55.9134C60.6643 51.1625 63.3333 44.7189 63.3333 38C63.3333 31.2812 60.6643 24.8376 55.9134 20.0867C51.1625 15.3357 44.7188 12.6667 38 12.6667ZM38 19C38.7756 19.0001 39.5242 19.2849 40.1038 19.8003C40.6835 20.3157 41.0538 21.0259 41.1445 21.7962L41.1667 22.1667V36.689L49.7388 45.2612C50.3068 45.8311 50.6365 46.5957 50.6611 47.3999C50.6856 48.2041 50.4032 48.9875 49.871 49.5909C49.3389 50.1944 48.5971 50.5727 47.7962 50.649C46.9952 50.7253 46.1953 50.4938 45.5588 50.0017L45.2612 49.7389L35.7612 40.2389C35.269 39.7463 34.9529 39.1052 34.8618 38.4149L34.8333 38V22.1667C34.8333 21.3269 35.167 20.5214 35.7608 19.9275C36.3547 19.3337 37.1601 19 38 19Z"
                    fill="#999999"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_32_433">
                    <rect width="76" height="76" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <label
                style="
                  color: #4c4c4c;
                  padding-left: 1em;
                  font-weight: 700;
                  font-size: 18px;
                "
              >
              {{ $t("TotalModels") }}
                <br /><span style="color: #8e8e8e; font-size: 40px">{{ totalusagegptflow }}</span>
                <span style="color: #8e8e8e"
                  >&nbsp;/{{$t("WithinThisDaysAgo")}} {{ daysDifference }} {{$t("Day")}}
                </span
                >
              </label>
            </v-card>
          </v-skeleton-loader>
        </v-col>
      </v-row>

      <v-row class="my-4">
        <v-col cols="12" sm="12" md="12" class="d-flex flex-row align-end">
          <label style="font-size: 20px; color: #757575; font-weight: 700">{{ $t("Usage") }}</label>
          <v-spacer></v-spacer>
          <label style="font-size: 12px; color: #f70707; font-weight: 800; margin-right: 8px;">1 USD = 35 THB</label>
          <label style="font-size: 14px; color: #757575; font-weight: 700">Show Price</label>
          <v-switch 
            id="showprice-switch-dashboard" 
            class="mt-0 ml-2" 
            hide-details 
            v-model="showPrice"
            density="compact"
            inset
            color="primary"
          ></v-switch>
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <v-skeleton-loader :loading="loadingCard" type="card">
            <v-card class="card-3 d-flex align-center mb-6">
              <label
                style="
                  color: #4c4c4c;
                  padding-left: 1em;
                  font-weight: 700;
                  font-size: 18px;
                "
              >
                {{ !showPrice ? $t("TokensUsed") : $t("totalExpense") }}
                <br /><span style="color: #8e8e8e; font-size: 48px">{{ !showPrice ? (totalusagetoken) : formatNumberWithComma(parseFloat(TotalUsedprice)) }} {{ !showPrice ? "" : $t("baht") }}</span>
                <br /><span style="color: #8e8e8e">{{$t("WithinThisDaysAgo")}} {{ daysDifference }} {{$t("Day")}}</span>
              </label>
            </v-card>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <v-skeleton-loader :loading="loadingCard" type="card">
            <v-card class="card-3 d-flex align-center mb-6">
              <label
                style="
                  color: #4c4c4c;
                  padding-left: 1em;
                  font-weight: 700;
                  font-size: 18px;
                "
              >
                {{ !showPrice ? $t("TokensUsedTokensChat") : $t("priceForAllChatUsage") }} 
                <br /><span style="color: #8e8e8e; font-size: 48px">{{ !showPrice ? totalusagetokenschat : formatNumberWithComma(parseFloat(TotalUsageChatPrice)) }} {{ !showPrice ? "" : $t("baht") }}</span>
                <br /><span style="color: #8e8e8e">{{$t("WithinThisDaysAgo")}} {{ daysDifference }} {{$t("Day")}}</span>
              </label>
            </v-card>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <v-skeleton-loader :loading="loadingCard" type="card">
            <v-card class="card-3 d-flex align-center mb-6">
              <label
                style="
                  color: #4c4c4c;
                  padding-left: 1em;
                  font-weight: 700;
                  font-size: 18px;
                "
              >
                {{ !showPrice ? $t("TokensUsedEmbedding") : $t("totalPriceForEmbedding")}}
                <br /><span style="color: #8e8e8e; font-size: 48px">{{ !showPrice ? totalusagetokensembedding : formatNumberWithComma(parseFloat(TotalEmbeddingPrice)) }} {{ !showPrice ? "" : $t("baht") }}</span>
                <br /><span style="color: #8e8e8e">{{$t("WithinThisDaysAgo")}} {{ daysDifference }} {{$t("Day")}}</span>
              </label>
            </v-card>
          </v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="12" md="4">
          <v-skeleton-loader :loading="loadingCard" type="card">
            <v-card class="card-3 d-flex align-center mb-6">
              <label
                style="
                  color: #4c4c4c;
                  padding-left: 1em;
                  font-weight: 700;
                  font-size: 18px;
                "
              >
                {{ !showPrice ? $t("ImageGenTotal") : $t("ImageGenTotalPrice")}}
                <br /><span style="color: #8e8e8e; font-size: 48px">{{ !showPrice ? totalAllImgGenerated : formatNumberWithComma((parseFloat(totalAllImgPrice) * 35).toFixed(2)) }} {{ !showPrice ? "" : $t("baht") }}</span>
                <br /><span style="color: #8e8e8e">{{$t("WithinThisDaysAgo")}} {{ daysDifference }} {{$t("Day")}}</span>
              </label>
            </v-card>
          </v-skeleton-loader>
        </v-col>
        <v-expansion-panels v-model="panel" multiple variant="plain" elevation="0">
          <v-expansion-panel bg-color="#FFF" elevation="0">
            <v-expansion-panel-title>
              <span style="font-size: 20px; color: #757575; font-weight: 700">{{ $t("DetailTokensUsedTokensChat") }}</span>
              <template v-slot:actions>
                <v-icon>mdi-chevron-down</v-icon>
              </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-skeleton-loader
                    :loading="loadingCard"
                    type="card"
                  >
                  <v-card class="card-3 d-flex align-center mb-6">
                    <label
                      style="
                        color: #4c4c4c;
                        padding-left: 1em;
                        font-weight: 700;
                        font-size: 18px;
                      "
                    >
                      {{  !showPrice ? $t("TokensUsedPromptTokensChat") : $t("totalPriceOfPromptChat") }}
                      <br /><span style="color: #8e8e8e; font-size: 48px">{{
                        !showPrice ? totalusageprompttokenschat : formatNumberWithComma(parseFloat(PromptPriceResult))
                      }} {{ !showPrice ? "" : $t("baht") }}</span>
                      <br /><span style="color: #8e8e8e">{{$t("WithinThisDaysAgo")}} {{ daysDifference }} {{$t("Day")}}</span>
                    </label>
                  </v-card>
                  </v-skeleton-loader>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-skeleton-loader
                    :loading="loadingCard"
                    type="card"
                  >
                  <v-card class="card-3 d-flex align-center mb-6">
                    <label
                      style="
                        color: #4c4c4c;
                        padding-left: 1em;
                        font-weight: 700;
                        font-size: 18px;
                      "
                    >
                      {{  !showPrice ? $t("TokensUsedCompletionTokensChat") : $t("totalPriceOfCompletionChat") }}
                      <br /><span style="color: #8e8e8e; font-size: 48px">{{
                        !showPrice ? totalusagecompletiontokenschat : formatNumberWithComma(parseFloat(CompletionResult))
                      }} {{ !showPrice ? "" : $t("baht") }}</span>
                      <br /><span style="color: #8e8e8e">{{$t("WithinThisDaysAgo")}} {{ daysDifference }} {{$t("Day")}}</span>
                    </label>
                  </v-card>
                  </v-skeleton-loader>
                </v-col>
              </v-row>
              <v-row v-for="item in listDetailTokenUsed" :key="item.key">
                <v-col cols="12" sm="12" md="4" v-if="listDetailTokenUsed != null">
                  <v-skeleton-loader
                    :loading="loadingCard"
               
                    type="card"
                  >
                  <v-card v-if="showCardgemini = true" class="card-3 d-flex align-center mb-6">
                    <label
                      style="
                        color: #4c4c4c;
                        padding-left: 1em;
                        font-weight: 700;
                        font-size: 18px;
                      "
                    >
                      {{ !showPrice ? $t("TokensUsedPromptTokensChat") : $t("totalPriceOfPromptChat") }} ({{item.modelName}})
                      <br /><span style="color: #8e8e8e; font-size: 48px">{{
                        !showPrice ? item.totalPrompt_tokens : formatNumberWithComma(parseFloat(item.totalPrompt_Price))
                      }} {{ !showPrice ? "" : $t("baht") }}</span>
                      <br /><span style="color: #8e8e8e">{{$t("WithinThisDaysAgo")}} {{ daysDifference }} {{$t("Day")}}</span>
                    </label>
                  </v-card>
                  </v-skeleton-loader>
                </v-col>
                <v-col cols="12" sm="12" md="4" v-if="listDetailTokenUsed != null">
                  <v-skeleton-loader
                    :loading="loadingCard"
                    type="card"
                  >
                  <v-card class="card-3 d-flex align-center mb-6">
                    <label
                      style="
                        color: #4c4c4c;
                        padding-left: 1em;
                        font-weight: 700;
                        font-size: 18px;
                      "
                    >
                      {{ !showPrice ? $t("TokensUsedCompletionTokensChat") : $t("totalPriceOfCompletionChat") }} ({{item.modelName}})
                      <br /><span style="color: #8e8e8e; font-size: 48px">{{
                        !showPrice ? item.totalCompletion_tokens : formatNumberWithComma(parseFloat(item.totalCompletion_Price))
                      }} {{ !showPrice ? "" : $t("baht") }}</span>
                      <br /><span style="color: #8e8e8e">{{$t("WithinThisDaysAgo")}} {{ daysDifference }} {{$t("Day")}}</span>
                    </label>
                  </v-card>
                  </v-skeleton-loader>
                </v-col>
              </v-row>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
        
        <v-expansion-panels v-model="panel2" multiple variant="plain" elevation="0">
          <v-expansion-panel bg-color="#FFF" elevation="0">
            <v-expansion-panel-title>
              <span style="font-size: 20px; color: #757575; font-weight: 700">{{ $t("DetailImageGenChat") }}</span>
              <template v-slot:actions>
                <v-icon>mdi-chevron-down</v-icon>
              </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-skeleton-loader
                    :loading="loadingCard"
                    type="card"
                  >
                  <v-card class="card-3 d-flex align-center mb-6">
                    <label
                      style="
                        color: #4c4c4c;
                        padding-left: 1em;
                        font-weight: 700;
                        font-size: 18px;
                      "
                    >
                      {{  !showPrice ? $t("ImageGenTotalInChat") : $t("ImageGenTotalPriceInChat") }}
                      <br /><span style="color: #8e8e8e; font-size: 48px">{{
                        !showPrice ? totalImgGenerated : formatNumberWithComma((parseFloat(totalImgPrice) * 35).toFixed(2))
                      }} {{ !showPrice ? "" : $t("baht") }}</span>
                      <br /><span style="color: #8e8e8e">{{$t("WithinThisDaysAgo")}} {{ daysDifference }} {{$t("Day")}}</span>
                    </label>
                  </v-card>
                  </v-skeleton-loader>
                </v-col>
              </v-row>
              <v-row v-for="item in listImgModelGen" :key="item.key">
                <v-col cols="12" sm="12" md="4" v-if="listImgModelGen != null">
                  <v-skeleton-loader
                    :loading="loadingCard"
               
                    type="card"
                  >
                  <v-card v-if="showCardgemini = true" class="card-3 d-flex align-center mb-6">
                    <label
                      style="
                        color: #4c4c4c;
                        padding-left: 1em;
                        font-weight: 700;
                        font-size: 18px;
                      "
                    >
                      {{ !showPrice ? $t("ImageGenTotalInChat") : $t("ImageGenTotalPriceInChat") }} ({{item.modelName}})
                      <br /><span style="color: #8e8e8e; font-size: 48px">{{
                        !showPrice ? item.totalGeneration : formatNumberWithComma((parseFloat(item.totalPrice) * 35).toFixed(2))
                      }} {{ !showPrice ? "" : $t("baht") }}</span>
                      <br /><span style="color: #8e8e8e">{{$t("WithinThisDaysAgo")}} {{ daysDifference }} {{$t("Day")}}</span>
                    </label>
                  </v-card>
                  </v-skeleton-loader>
                </v-col>
              </v-row>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>

      <v-row class="my-4">
        <v-col cols="12" sm="12" md="12">
          <label style="font-size: 20px; color: #757575; font-weight: 700"
            >Statistics</label
          >
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-skeleton-loader :loading="loadingCard" type="card">
            <v-card class="card-2">
              <highcharts v-if="isChartOptions" :options="chartOptions"></highcharts>
            </v-card>
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
    
    <!-- <v-dialog v-model="dialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading Please Wait...
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog> -->
    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import { Chart } from "highcharts-vue";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
export default {
  name: "Dashboard",
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround"
  ],
  computed: {
    currentLanguage() {
      return this.$i18n.locale;
    },
  },
  watch: {
    currentLanguage(newLanguage) {
      // อัปเดตข้อความหรือสถานะ component เมื่อภาษาเปลี่ยน
      this.loadTranslations(newLanguage); // เรียกฟังก์ชันเพื่อโหลดข้อมูลหรือข้อความใหม่
    },
  },
  components: {
    highcharts: Chart,
  },
  data: () => ({
    mask: "##########",
    show1: false,
    dialog: false,
    loading: false,
    userList: [],
    panel: [0],
    panel2: [0],
    daysDifference:0,
    // userId: Cookies.get("userId"),
    today: null,
    totalusage: 0,
    totalusageunit: "month",
    totalusagelastday: 0,
    totalusagelastdayupdatedin: "-",
    totalusagelastdayupdatedinDate: null,
    totalusagetoken: 0,
    totalusagetokenunit: "month",
    totalusagetokenschat: 0,
    totalusageprompttokenschat: 0,
    totalusagecompletiontokenschat: 0,
    totalusagetokensembedding: 0,
    totalusageuser: 0,
    totalusageusermax: 0,
    totalusageuserunit: "month",
    totalusagegptflow: 0,
    totalusagepraphcategories: [],
    totalusagepraphdata: [],
    totalImgModelGen: [],
    language: "th",

    startDateFlag: false,
    endDateFlag: false,
    startDate: null,
    endDate: null,
    loadingCard: false, 
    provider: null,

    rules: {
      required: (value) => !!value || "Required",
    },
    // chartOptions: {
    //   series: [{
    //     data: [1, 2, 3] // sample data
    //   }]
    // },
    isChartOptions: false,
    chartOptions: {
      chart: { type: "column" },
      title: { text: "" },
      subtitle: { text: "" },
      credits: { enabled: false },
      xAxis: { categories: ["1x", "2x", "3x", "4x"], crosshair: true },
      yAxis: { min: 0, title: { text: "จำนวนคน" } },
      tooltip: {
        enabled: false,
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b> {point.y:,.0f} คน</b></td></tr>',
        footerFormat: "</table>",
        shared: false,
        useHTML: false,
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return parseFloat(this.y.toFixed(2)).toLocaleString() + " คน";
            },
          },
        },
      },
      series: [
        {
          name: "จำนวนคน",
          data: [1000000, 1, 1, 1],
          color: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, "#9747FF"],
              [1, "#5179EF"],
            ],
          },
        },
      ],
    },
    listDDProvider: [],
    showCardgemini: false,
    showPrice: false,
    CompletionResult: 0,
    PromptPriceResult: 0,
    TotalEmbeddingPrice: 0,
    TotalUsageChatPrice: 0,
    TotalUsedprice: 0,
    PromptPriceGPT3: 0,
    PromptPriceGPT316k: 0,
    PromptPriceGPT4: 0,
    PromptPriceOther: 0,
    CompletionPriceGPT3: 0,
    CompletionPriceGPT316k: 0,
    CompletionPriceGPT4: 0,
    CompletionPriceOther: 0,
    TotalGpt35Prompt: 0, 
    TotalGpt316kPrompt: 0, 
    TotalGpt4Prompt: 0, 
    TotalGpt35Completion: 0, 
    TotalGpt316kCompletion: 0, 
    TotalGpt4Completion: 0, 
    listDetailTokenUsed: null,
    totalImgGenerated: 0,
    totalImgPrice: 0,
    totalAllImgGenerated: 0,
    totalAllImgPrice: 0,
    listImgModelGen: [],
  }),
  methods: {    
    formatDate(dateInput) {
      if (!dateInput) {
        return '';
      }
      if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
        return dateInput;
      }
      
      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const date = `${year}-${month}-${day}`;
      return date;
    },
    loadTranslations(newLanguage) {
      this.language = newLanguage;
      let p = this.$t("People");
      if (this.language == "th" && this.totalusagelastdayupdatedinDate)
        this.totalusagelastdayupdatedin = this.convertDateToStringTh(
          this.totalusagelastdayupdatedinDate
        );
      else if(this.totalusagelastdayupdatedinDate)
        this.totalusagelastdayupdatedin = this.convertDateToStringEn(
          this.totalusagelastdayupdatedinDate
        );
      this.chartOptions.title = { text: this.$t("UserUsage") };
      this.chartOptions.subtitle = { text: this.$t("TotalUsagePerMonth") };
      this.chartOptions.yAxis = {
        min: 0,
        title: { text: this.$t("NumberPeople") },
      };
      this.chartOptions.plotOptions = {
        column: {
          pointPadding: 0,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return parseFloat(this.y.toFixed(2)).toLocaleString() + ` ${p}`;
            },
          },
        },
      };
      this.chartOptions.series = [
        {
          name: this.$t("NumberPeople"),
          data: this.totalusagegraphdata,
          color: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, "#9747FF"],
              [1, "#5179EF"],
            ],
          },
        },
      ];
    },
    ConvertFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatNumberWithComma(value) { 
      const [integerPart, decimalPart] = value.toString().split('.');
      const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      const formattedDecimalPart = decimalPart ? `.${decimalPart}` : '';
      return formattedIntegerPart + formattedDecimalPart;
    },
    calculateDaysBetween(start, end) {
      const startDate = new Date(start);
      const endDate = new Date(end);

      // Check if dates are valid
      if (isNaN(startDate) || isNaN(endDate)) {
          return "Invalid date";
      }

      // Calculate the difference in time
      const timeDifference = endDate - startDate;

      // Convert time difference from milliseconds to days
      this.daysDifference = timeDifference / (1000 * 3600 * 24) + 1;
    },
    Search() {
      let self = this;
      self.loading = true;
      self.loadingCard = true;
      self.Get();
    },
    async GetProviderData() {
      let self = this;
      self.dialog = true;
      await self.$call.GetDDLProviderData(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDProvider = dataResponse.data;
            self.listDDProvider.push({id: 0, providerName: "All"});
            self.listDDProvider.sort(function(a, b) {
              if (a.id < b.id) {
                  return -1;
              }
              if (a.id > b.id) {
                  return 1;
              }
              return 0;
          }); 

          // for(let i = 0; i < dataResponse.data.length; i++)
          // {
          //   self.listDDProvider.push(dataResponse.data[i]);
          // }
            
          } else {
            self.listDDProvider = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    Get() {
      if(this.startDate != null && this.endDate != null)
      {
        this.calculateDaysBetween(this.startDate, this.endDate);
        let temp = {
          StartDate: this.startDate,
          EndDate: this.endDate,
          ProviderName: this.provider,
        };
        this.loadingCard = true;
      this.$call.GetDashboardOverview(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            const data = dataResponse.data;
            this.totalusage = this.ConvertFormat(data.totalUsage);
            this.totalusageunit = data.totalUsageUnit;
            this.totalusagelastday = this.ConvertFormat(data.totalUsageLastDay);
            this.totalusagelastdayupdatedinDate = data.totalUsageLastDayUpdatedIn;
            this.totalImgModelGen = data.totalImageModelGeneration;
            this.totalAllImgGenerated = data.totalGenImg;
            this.totalAllImgPrice = data.totalGenImgPrice;
            // if(this.provider == "Azure"){
            //   this.totalusageprompttokenschat = this.ConvertFormat(data.modelTokens.totalPrompt_tokens).Sum();
            //   this.totalusagecompletiontokenschat = this.ConvertFormat(data.modelTokens.totalCompletion_tokens).Sum();
            //   this.totalusagetokenschat =  this.ConvertFormat(this.totalusageprompttokenschat + this.totalusagecompletiontokenschat);
            //   this.totalusagetoken = this.ConvertFormat(data.totalUsageTokensEmbedding  this.totalusagetokenschat);
            //   console.log()
            // }
            // else if (this.provider == "Google"){
            //   this.totalusageprompttokenschat = this.ConvertFormat(data.modelTokens.totalPrompt_tokens).Sum();
            //   this.totalusagecompletiontokenschat = this.ConvertFormat(data.modelTokens.totalCompletion_tokens).Sum();
            //   this.totalusagetokenschat =  this.ConvertFormat(this.totalusageprompttokenschat + this.totalusagecompletiontokenschat);
            //   this.totalusagetoken = this.ConvertFormat(data.totalUsageTokensEmbedding + this.totalusagetokenschat);
            //   console.log()
            // }
            // else if (this.provider == "Anthropic"){
            //   this.totalusageprompttokenschat = this.ConvertFormat(data.modelTokens.totalPrompt_tokens).Sum();
            //   this.totalusagecompletiontokenschat = this.ConvertFormat(data.modelTokens.totalCompletion_tokens).Sum();
            //   this.totalusagetokenschat =  this.ConvertFormat(this.totalusageprompttokenschat + this.totalusagecompletiontokenschat);
            //   this.totalusagetoken = this.ConvertFormat(data.totalUsageTokensEmbedding + this.totalusagetokenschat);
            //   console.log()
            // }
            if(this.provider == "All")
            {
              this.totalImgGenerated = this.ConvertFormat(this.totalImgModelGen.reduce((sum, item) => sum + (item.totalGeneration || 0), 0));
              this.listImgModelGen = this.totalImgModelGen;
              this.totalImgPrice = 0;
              this.listImgModelGen.forEach(e => {
                this.totalImgPrice += parseFloat(e.totalPrice).toFixed(2);
              });

              this.totalusagetoken = this.ConvertFormat(data.totalUsageToken);
              this.totalusagetokenschat =  this.ConvertFormat(data.totalUsageTokensChat);
              this.totalusagetokensembedding = this.ConvertFormat(data.totalUsageTokensEmbedding);
              this.totalusageprompttokenschat = this.ConvertFormat(data.totalUsagePromptTokensChat);
              this.totalusagecompletiontokenschat = this.ConvertFormat(data.totalUsageCompletionTokensChat);
            }
            else{
              this.totalImgGenerated = this.ConvertFormat(this.totalImgModelGen.filter(e => e.provider == this.provider).reduce((sum, item) => sum + (item.totalGeneration || 0), 0));
              this.listImgModelGen = this.totalImgModelGen.filter(e => e.provider == this.provider);
              
              this.totalImgPrice = 0;
              this.listImgModelGen.forEach(e => {
                this.totalImgPrice += parseFloat(e.totalPrice).toFixed(2);
              });

              let temp = data.modelTokens.filter(e => e.provider == this.provider);
              let temptotalusageprompttokenschat = temp.reduce((sum, o) => (sum + parseFloat(o.totalPrompt_tokens)), 0)
              let temptotalusagecompletiontokenschat = temp.reduce((sum, o) => (sum + parseFloat(o.totalCompletion_tokens)), 0) 
              let temptotalusagetokenschat = temptotalusageprompttokenschat + temptotalusagecompletiontokenschat      
              this.totalusageprompttokenschat = this.ConvertFormat(temptotalusageprompttokenschat);
              this.totalusagecompletiontokenschat = this.ConvertFormat(temptotalusagecompletiontokenschat);
              this.totalusagetokensembedding = this.ConvertFormat(data.totalUsageTokensEmbedding);
              this.totalusagetokenschat =  this.ConvertFormat(temptotalusagetokenschat);
              this.totalusagetoken = this.ConvertFormat(data.totalUsageTokensEmbedding + temptotalusagetokenschat);
            }
            // this.totalusagetoken = this.ConvertFormat(data.totalUsageToken);
            // this.totalusagetokenschat =  this.ConvertFormat(data.totalUsageTokensChat);
            // this.totalusagetokensembedding = this.ConvertFormat(data.totalUsageTokensEmbedding);
            // this.totalusageprompttokenschat = this.ConvertFormat(data.totalUsagePromptTokensChat);
            // this.totalusagecompletiontokenschat = this.ConvertFormat(data.totalUsageCompletionTokensChat);

            this.totalusagetokenunit = data.totalUsageTokenUnit;
            this.totalusageuser = this.ConvertFormat(data.totalUsageUser);
            this.totalusageusermax = this.ConvertFormat(data.totalUsageUserMax);
            this.totalusageuserunit = data.totalUsageUserUnit;
            this.totalusagegptflow = this.ConvertFormat(data.totalUsageGPTFlow);
            this.totalusagegraphcategories = data.totalUsageGraphCategories;
            this.totalusagegraphdata = data.totalUsageGraphData;
            this.listDetailTokenUsed = data.modelTokens.map((items,index) => ({
              key: index + 1 ,
              provider: items.provider,
              modelName: items.modelName,
              completionPrice: items.completionPrice,
              promptPrice: items.promptPrice,
              totalPrompt_Price: ((parseFloat(((parseInt(items.totalPrompt_tokens) / 1000) * items.promptPrice) * 35)).toFixed(2)),
              totalCompletion_Price: (parseFloat(((parseInt(items.totalCompletion_tokens) / 1000) * items.completionPrice) * 35)).toFixed(2),
              totalCompletion_tokens: this.ConvertFormat(items.totalCompletion_tokens),
              totalPrompt_tokens: this.ConvertFormat(items.totalPrompt_tokens),
            }))
            
            if(this.provider != "All")
            {
              this.listDetailTokenUsed = this.listDetailTokenUsed.filter(e => e.provider == this.provider);
            }

            const promtPrice = (parseFloat(this.listDetailTokenUsed.reduce((sum, o) => (sum + parseFloat(o.totalPrompt_Price)), 0))).toFixed(2)
            const completionPrice = (parseFloat(this.listDetailTokenUsed.reduce((sum, o) => (sum + parseFloat(o.totalCompletion_Price)), 0))).toFixed(2)
            const totalUsageChatPrice = (parseFloat(completionPrice) + parseFloat(promtPrice)).toFixed(2)
            const totalEmbeddingPrice = (parseFloat(((data.totalUsageTokensEmbedding / 1000) * 0.0001) * 35)).toFixed(2)
            const totalUsedprice = ((parseFloat(totalUsageChatPrice)+parseFloat(totalEmbeddingPrice))).toFixed(2)
 
            this.PromptPriceResult = (promtPrice);
            this.CompletionResult = (completionPrice);
            this.TotalEmbeddingPrice = (totalEmbeddingPrice);
            this.TotalUsageChatPrice = (totalUsageChatPrice);
            this.TotalUsedprice = (totalUsedprice);

            this.chartOptions.xAxis.categories = this.totalusagegraphcategories;

            // จัดการเรื่องภาษาของ chart
            if (this.language == "th")
              this.totalusagelastdayupdatedin = this.convertDateToStringTh(
                this.totalusagelastdayupdatedinDate
              );
            else
              this.totalusagelastdayupdatedin = this.convertDateToStringEn(
                this.totalusagelastdayupdatedinDate
              );
            let p = this.$t("People");
            this.chartOptions.title = { text: this.$t("UserUsage") };
            this.chartOptions.subtitle = {
              text: this.$t("TotalUsagePerMonth"),
            };
            this.chartOptions.yAxis = {
              min: 0,
              title: { text: this.$t("NumberPeople") },
            };
            this.chartOptions.plotOptions = {
              column: {
                pointPadding: 0,
                borderWidth: 0,
                dataLabels: {
                  enabled: true,
                  formatter: function () {
                    return (
                      parseFloat(this.y.toFixed(2)).toLocaleString() + ` ${p}`
                    );
                  },
                },
              },
            };
            this.chartOptions.series = [
              {
                name: this.$t("NumberPeople"),
                data: this.totalusagegraphdata,
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, "#9747FF"],
                    [1, "#5179EF"],
                  ],
                },
              },
            ];

            this.isChartOptions = true;
          }
          this.loadingCard = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.Adddialog = false;
          console.error(errorResource);
          this.loadingCard = false;
        }
      );
      }
      // else
      // {
      //   self.$swal.fire({
      //     icon: 'warning',
      //     title: self.$t('warning'),
      //     text: 'Please fill the required fields!!!',
      //     showConfirmButton: false,
      //     timer: 1800,
      //   });
      //   self.loading = false;
      //   return;
      // }
    },
    convertDateToStringEn(date, seperator = "/") {
      return dateUtils.getStringWithMonthEnNameFromDate(
        moment(date).toDate(),
        seperator
      );
    },
    convertDateToStringTh(date, seperator = "/") {
      return dateUtils.getStringWithMonthNameFromDate(
        moment(date).toDate(),
        seperator
      );
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },

    convertDateToString(date, seperator = '/') {
      return dateUtils.getStringWithTimeFromDate(moment(date).toDate(), seperator);
    },
    convertDateToString2(date, seperator = '-') {
      return dateUtils.getStringFromDatePickFormatDatePick2(moment(date).toDate(), seperator);
    },
  },
  mounted() {
    let self = this;
    self.loadingCard = true;
    self.GetDate();
    var datesubtract = new Date();
    datesubtract.setDate(datesubtract.getDate() - 2);
    var date = new Date();
    self.startDate = self.convertDateToString2(datesubtract);
    self.endDate = self.convertDateToString2(date);
    self.GetProviderData();
    self.Get();
    self.provider = "All";
    self.language = self.$i18n.locale;
  },
};
</script>
<style scoped>
.card-1 {
  border-radius: 13px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 125px;
  flex-shrink: 0;
}

.card-2 {
  border-radius: 13px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 400px;
  flex-shrink: 0;
}

.card-3 {
  border-radius: 13px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 160px;
  flex-shrink: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.circular--portrait {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 50%;
}

.circular--portrait img {
  width: 100%;
  height: auto;
}

.gradient-red {
  background: -webkit-linear-gradient(red, yellow);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradient-purple {
  background: -webkit-linear-gradient(#9747ff, #5179ef);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

</style>
